<template>
  <!-- 毕业展 -->
  <div class="search_result_task">
    <!-- 列表信息 -->
    <div class="designList_box">
      <template v-if="layerpageinfo.total > 0">
        <div>
          <exhibitions_list :list="list" />
        </div>
        <!-- 分页 -->
        <div class="page_box">
          <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
        </div>
      </template>
      <div v-else class="no_search"></div>
    </div>
  </div>
</template>

<script>
import exhibitions_list from "@/components/list_item/exhibitions_list/exhibitions_list.vue";
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    exhibitions_list,
    myPage
  },
  data() {
    return {
      list: [],
      layerpageinfo: {
        pageSize: 6,
        pageNo: 0,
        total: 0
      },
    };
  },
  props: {
    searchText: {
      type: String
    }
  },
  created() {
    this.search();
  },
  methods: {
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getList();
    },
    search() {
      this.layerpageinfo.pageNo = 0;
      this.getList();
    },
    getList(){
      this.api.getFrontExhibitions({ name: this.searchText ,...this.layerpageinfo,status:'IdentityCertifieStatussuccess'}).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        this.list = list.length ? list : [];
        this.layerpageinfo.total = res.obj.totalSize;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// 设计任务
.search_result_task {
  margin-top: 20px;
  margin-bottom: 60px;
  // 标题
  h3.design_h3 {
    font-size: 34px;
    color: $font-black;
    line-height: 114px;
    padding-top: 40px;
  }
  // 列表信息
  .designList_box {
    width: 100%;
    ul {
      display: flex;
      flex-wrap: wrap;
    }
  }
}
</style>
